export const albumSortType = Object.freeze({
  ID: 'id',
  CREATED_AT: 'createdAt',
  TITLE: 'title',
  MEDIA_CREATED_AT: 'mediaCreatedAt',
});
